module.exports = __webpack_public_path__ + "img/team.1c87b6cd.svg";